import { render, staticRenderFns } from "./MilestoneTemplateViewForm.vue?vue&type=template&id=db20f646&"
import script from "./MilestoneTemplateViewForm.vue?vue&type=script&lang=js&"
export * from "./MilestoneTemplateViewForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports